<template>
  <div>
    <app-header title="Countries" />
    <loading-spinner v-if="!countries" />
    <b-container v-else >
      <b-row>
        <b-col>
          <search-input v-model="query" />
        </b-col>
        <b-col class="text-right">
          {{ total }} Countries
        </b-col>
      </b-row>
      <b-card-group columns>
        <b-card
          v-for="country in displayCountries"
          :key="country.id"
          v-router-link="{name:'country-detail',params:country}"
          no-body
        >
          <b-card-body>
            <h3>{{ country.name }}</h3>
            <p>Country</p>
          </b-card-body>
        </b-card>
      </b-card-group>
      <infinite-scrolling @infiniteHandler="infiniteHandler" />
    </b-container>
  </div>
</template>

<script>
import $api from '@/services/api';
import $search from '@/services/search';
import AppHeader from '@/components/AppHeader';
import SearchInput from '@/components/SearchInput';
import LoadingSpinner from '@/components/LoadingSpinner';
import InfiniteScrolling from '@/components/InfiniteScrolling';

export default {
  components: {
    AppHeader,
    SearchInput,
    LoadingSpinner,
    InfiniteScrolling,
  },

  data() {
    return {
      query: '',
      countries: null,
      page: 0,
      perPage: 7,
    };
  },

  computed: {
    displayCountries() {
      return $search(this.countries, this.query).slice(0, this.perPage * this.page);
    },

    total() {
      return (this.query) ? this.displayCountries.length : this.countries.length;
    },
  },

  created() {
    this.refreshData();
  },

  methods: {
    async refreshData() {
      this.countries = await $api.get('/v1/internal/countries');
    },

    infiniteHandler($state) {
      if ((this.perPage * this.page) <= this.countries.length) {
        this.page += 1;
        $state.loaded();
      } else {
        $state.complete();
      }
    },
  },
};
</script>
